module.exports = __webpack_public_path__ + "static/media/BabyCourse_Mobile_11.74d57242.jpf";